import React from 'react'
import { FormattedMessage } from 'react-intl'

class Faq extends React.Component {
    render() {
        return (
            <div className="faq container">
                <h2>FAQs</h2>
                <div className="faq__columns">
                    <div className="faq__col1">
                        <FormattedMessage id="es_necesaria_conexion_a_internet_para_el_funcionamiento" defaultMessage="¿Es necesaria conexión a internet para el funcionamiento?" />
                        <br />
                        <FormattedMessage
                            id="no_el_sistema_es_capaz_de_funcionar_de_manera_autónoma_utilizando_la_conexión_de_datos_del_Smartphone_del_inquilino_para_realizar_la_autenticación_y_la_apertura_de_la_puerta"
                            defaultMessage="No, el sistema es capaz de funcionar de manera autónoma utilizando la conexión de datos del Smartphone del inquilino para realizar la autenticación y la apertura de la puerta."
                        />
                    </div>
                    <div className="faq__col2">
                        <FormattedMessage id="se_usan_datos_moviles_para_la_apertura" defaultMessage="¿Se usan datos móviles para la apertura?" />
                        <br />
                        <FormattedMessage
                            id="aunque_se_recomienda_el_uso_de_datos_para_poder_realizar_la_apertura_desde_la_calle_el_sistema_dispone_de_la_opción_de_realizar_la_apertura_mediante_llamada_perdida_en_caso_de_no_disponer_de_datos"
                            defaultMessage="Aunque se recomienda el uso de datos para poder realizar la apertura desde la calle, el sistema dispone de la opción de realizar la apertura mediante llamada perdida en caso de no disponer de datos."
                        />
                    </div>
                    <div className="faq__col3">
                        <FormattedMessage id="que_tipo_de_cerradura_debo_instalar" defaultMessage="¿Qué tipo de cerradura debo instalar?" />
                        <br />
                        <FormattedMessage
                            id="existen_multitud_de_cerraduras_electrónicas_compatibles_con_el_sistema_funcionamos_con_fabricantes_líderes_como_tesa_locken_o_salto"
                            defaultMessage="Existen multitud de cerraduras electrónicas compatibles con el sistema, funcionamos con fabricantes líderes como TESA, LOCKEN o SALTO."
                        />
                    </div>
                    <div className="faq__col4">
                        <FormattedMessage
                            id="es_necesario_instalar_algo_en_el_portal_o_en_las_zonas_comunes"
                            defaultMessage="¿Es necesario instalar algo en el portal o en las zonas comunes?"
                        />
                        <br />
                        <FormattedMessage
                            id="no_es_necesaria_la_instalacion_de_ningun_aparato_en_las_zonas_comunes_de_tu_ediﬁcio_todas_las_conexiones_se_realizan_desde_el_interior_de_tu_vivienda_conectando_directamente_al_telefonillo"
                            defaultMessage="No es necesaria la instalación de ningún aparato en las zonas comunes de tu ediﬁcio, todas las conexiones se realizan desde el interior de tu vivienda conectando directamente al telefonillo."
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default Faq



// WEBPACK FOOTER //
// ./src/components/home/Faq.js